var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.totalErrors)?_c('v-icon',{attrs:{"color":"green"}},[_vm._v("mdi-check-circle")]):(_vm.warning)?_c('v-icon',{attrs:{"color":"#eed202"}},[_vm._v("mdi-alert-box")]):_c('v-icon',{attrs:{"color":"error"}},[_vm._v("mdi-alert-circle")])}
var staticRenderFns = []

export { render, staticRenderFns }